import { render, staticRenderFns } from "./MerchantReduction.vue?vue&type=template&id=340d435e&scoped=true&"
import script from "./MerchantReduction.vue?vue&type=script&lang=js&"
export * from "./MerchantReduction.vue?vue&type=script&lang=js&"
import style0 from "./MerchantReduction.vue?vue&type=style&index=0&id=340d435e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340d435e",
  null
  
)

export default component.exports